import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../lib/store";

export function useAdminData() {
  const [token, setToken] = useState(sessionStorage.getItem("rj_admin_token") || "");
  const [role, setRole] = useState(sessionStorage.getItem("rj_admin_role") || "admin");
  const [stats, setStats] = useState(null);
  const [inquiries, setInquiries] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncInfo, setSyncInfo] = useState(null);
  const [featured, setFeatured] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [media, setMedia] = useState([]);

  const loadAll = useCallback(async (tk) => {
    const h = { headers: { Authorization: `Bearer ${tk}` } };
    setLoading(true);
    try {
      const [s, i, b, sub, sync, rev, med] = await Promise.all([
        axios.get(`${API}/admin/stats`, h),
        axios.get(`${API}/admin/inquiries`, h),
        axios.get(`${API}/admin/bookings`, h),
        axios.get(`${API}/admin/subscribers`, h),
        axios.get(`${API}/admin/sync-status`, h),
        axios.get(`${API}/reviews`),
        axios.get(`${API}/admin/media`, h),
      ]);
      setStats(s.data);
      setInquiries(i.data);
      setBookings(b.data);
      setSubscribers(sub.data);
      setSyncInfo(sync.data);
      setFeatured((sync.data.featuredHandles || []).slice(0, 8));
      setReviews(rev.data || []);
      setMedia(med.data || []);
    } catch (e) {
      if (e.response?.status === 401) {
        sessionStorage.removeItem("rj_admin_token");
        setToken("");
        toast.error("Session expired — please log in again");
      } else toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (token && role !== "staff") loadAll(token);
  }, [token, role, loadAll]);

  const setAuthState = useCallback((tk, rl) => {
    sessionStorage.setItem("rj_admin_token", tk);
    sessionStorage.setItem("rj_admin_role", rl);
    setToken(tk);
    setRole(rl);
    window.dispatchEvent(new Event("rj-admin-auth"));
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem("rj_admin_token");
    sessionStorage.removeItem("rj_admin_role");
    setToken("");
    setRole("admin");
    window.dispatchEvent(new Event("rj-admin-auth"));
  }, []);

  return {
    token, role, setAuthState, logout, loadAll, loading,
    stats,
    inquiries, setInquiries,
    bookings, setBookings,
    subscribers,
    syncInfo, setSyncInfo,
    featured, setFeatured,
    reviews, setReviews,
    media, setMedia,
  };
}
